define('responsive-gameday-loginiframe/src/js/GamedayLoginIframe',['require','exports','module','jquery','es6ish-class/es6ish-class','requirejs-hogan-plugin/hogan','message-service/message-service','gameday-index-enums/enums/events/LoadEvents','text!../templates/gd_loginiframe.tpl','text!../templates/gd_loginiframe_upsell.tpl','gameday-index-enums/enums/events/OauthEvents'],function(require, module, exports) {

    var $ = require('jquery'),
        es6ishClass = require('es6ish-class/es6ish-class'),
        hogan = require('requirejs-hogan-plugin/hogan'),
        MessageService = require("message-service/message-service"),
        LoadEvts = require("gameday-index-enums/enums/events/LoadEvents"),
        loginIframeTemplate = hogan.compile(require('text!../templates/gd_loginiframe.tpl')),
        loginIframeUpsellTemplate = hogan.compile(require('text!../templates/gd_loginiframe_upsell.tpl')),
        OauthEvts = require("gameday-index-enums/enums/events/OauthEvents");

    var GamedayLoginIframe = es6ishClass(function(selectorString) {

        this.targetDivSelector = selectorString;
        this.currentStatus;
        this.loginTemplate = loginIframeTemplate;

    });



    GamedayLoginIframe.define({
        /**
         * Where are we placing this component?
         */
        targetDivSelector: "",

        checkOauthStatus: function() {

            if (this.currentStatus === OauthEvts.isNotLogin) {
                this.loadFrame(this.loginTemplate);
            } else if (this.currentStatus === OauthEvts.isLogin) {
                this.hide();
                MessageService.publish(OauthEvts.isLogin, this.componentID);
            }
        },

        init: function(config) {
            var that = this;
            var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
            var eventer = window[eventMethod];
            var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
            

            $(this.targetDivSelector).hide().html(loginIframeTemplate.render());

            eventer(messageEvent, function(e) {
                if (e.data === OauthEvts.userIsNotLogin) {
                    that.currentStatus = OauthEvts.isNotLogin;
                    that.loginTemplate = loginIframeTemplate;
                    MessageService.publish(OauthEvts.isNotLogin, that.componentID);
                } else if (e.data === OauthEvts.userIsLoginUpsell) {
                    that.currentStatus = OauthEvts.isLogin;
                } else if (e.data === OauthEvts.userIsLogin) {
                    that.currentStatus = OauthEvts.isLogin;
                    that.hide();
                    MessageService.publish(OauthEvts.isLogin, that.componentID);
                } else if (e.data === OauthEvts.loginHide) {
                    that.hide();
                    that.currentStatus =OauthEvts.isNotLogin;
                    MessageService.publish(OauthEvts.isNotLogin, that.componentID);
                }
            }, false);


            MessageService.on(OauthEvts.checkOauthStatus, function() {
                that.checkOauthStatus.call(that);
            });
            
            MessageService.on(OauthEvts.isLoginNoEntitlement, function() {
               that.loginTemplate = loginIframeUpsellTemplate;
               that.loadFrame();
            });

        },

        hide: function() {
             $(this.targetDivSelector).fadeOut();
        },
        
        loadFrame: function() {
            $(this.targetDivSelector).empty().html(this.loginTemplate.render()).show().height($("#mlb").height());
            
        },

        destory: function() {
            $(this.targetDivSelector).remove();
        }

    });

    return GamedayLoginIframe;
});
